// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type SeoLandingPageContextProperties = {
  component_PopularCarrierLogos?: number;
  component_UserReviews?: number;
  page_id: string;
  component_ClassesAndAmenities?: number;
  landing_page_type: string;
  arrival_position_id?: number;
  component_CheapestFastestIntent?: number;
  component_StationBoxes?: number;
  language: string;
  component_JourneySummary?: number;
  component_AdvancedBooking?: number;
  component_ModeComparison?: number;
  component_CheapestIntent?: number;
  component_SingleStationBoxes?: number;
  component_SoonIntent?: number;
  component_CheapestMonthBook?: number;
  component_FastestIntentV2?: number;
  component_AllIntent?: number;
  component_CarrierLogos?: number;
  travel_mode?: string;
  departure_position_id?: number;
  component_JumpLinks?: number;
  platform?: string;
  domain: string;
  component_FerrySchedule?: number;
  component_PriceCalendar?: number;
  component_ProviderInfo?: number;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/seo_landing_page_context/jsonschema/4-0-5';
export const seoLandingPageContextName = 'seo_landing_page_context';
export class SeoLandingPageContext extends BaseTrackingContext<SeoLandingPageContextProperties> {
  constructor(properties: SeoLandingPageContextProperties) {
    super(seoLandingPageContextName, schema, properties);
  }
}
